<template>
  <button
    class="w-full text-left uppercase border-b border-blue-400 py-2 pl-2 pr-1 focus:outline-none hover:bg-gray-200"
    :class="[
      isSelected ? 'item-selected' : '',
      isExcluded ? 'item-excluded' : '',
      sizeClass
    ]"
    @click="handleClick"
  >
    {{ text }}
  </button>
</template>

<script>
const sizeClasses = {
  extralarge: 'text-xl',
  large: 'text-lg',
  medium: 'text-base',
  small: 'text-small',
  extrasmall: 'text-xs'
}

export default {
  props: {
    // required
    text: {
      type: String,
      required: true
    },
    // optional
    number: {
      type: Number,
      required: false,
      default: null
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    isExcluded: {
      type: Boolean,
      required: false,
      default: false
    },
    textSize: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  computed: {
    sizeClass() {
      return sizeClasses[this.textSize]
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', {
        text: this.text,
        number: this.number != null ? this.number : null
      })
    }
  }
}
</script>

<style scoped>
.item-selected {
  color: white;
  background-color: #009845;
}
.item-excluded {
  color: white;
  background-color: #a9a9a9;
}
</style>
